import axios from "axios";

export const getDashboardData = async (navigate) => {
  const token = localStorage.getItem("token");
  const apiUrlDashboard = `${process.env.REACT_APP_API}dashboard`;

  if (!token) {
    console.error("No se encontró un token en localStorage");
    navigate("/login"); // Redirige al login si no hay token
    throw new Error(
      "Token no encontrado. Por favor, inicie sesión nuevamente.",
    );
  }

  try {
    const response = await axios.get(apiUrlDashboard, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.warn("Token no válido o expirado. Redirigiendo al login...");
      localStorage.removeItem("token"); // Elimina el token
      navigate("/login"); // Redirige al login
    }

    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message || "Error inesperado en el servidor"
        : "No se pudo conectar con el servidor";
    throw new Error(errorMessage); // Lanza un error genérico
  }
};
